export const GIFT_CARD_ZERO_BALANCE = 'CARTS-007';
export const GIFT_CARD_BALANCE_ERROR = 'CARTS-008';
export const GIFT_CARD_NOT_USED = 'CARTS-009';
export const DUPLICATE_GIFT_CARD = 'CARTS-010';
export const GIFT_CARD_MAX_APPLIED = 'CARTS-013';
